import type { SxProps } from "@mui/material";

export const buttonStyle: SxProps = {
  position: "relative",
};

export const dropdownStyle: SxProps = {
  minWidth: 65,
  mr: 2,
};

export const selectItemStyle: SxProps = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

export const selectStyle: SxProps = {
  borderTopLeftRadius: 0,
  borderBottomLeftRadius: 0,

  "& .MuiSelect-select": {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "24px !important",
    padding: "8px",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    border: "1px solid rgba(0, 0, 0, 0.12) !important",
  },
};

export const dropdownItemStyle: SxProps = {
  display: "flex",
  alignItems: "center",
  gap: 1,
};
